import React from 'react';
import { CircleBone, FrameBone, ParagraphBone } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import repeatElement from '@gik/core/utils/repeatElement';

export default function UserSettingsSkeleton() {
  const bem = bemBlock('user-settings-skeleton');
  return (
    <FrameBone className={bem()}>
      <CircleBone />

      <section className={bem('full-name')}>
        <ParagraphBone words={3} />
      </section>
      <section className={bem('email-address')}>
        <ParagraphBone words={3} />
      </section>
      <section className={bem('city-state')}>
        <div className="user-details-typography">
          <ParagraphBone words={4} />
        </div>
      </section>

      <div className={bem('buttons')}>{repeatElement(4, <ParagraphBone words={3} />)}</div>
    </FrameBone>
  );
}
